import { BaseDataTransferObject } from '../base-data-transfer-object';
import { ZipCode } from '../common';

export class ResponsibleParty extends BaseDataTransferObject {
    public code!: string;
    public patientId!: number;
    public order!: number;
    public lastName!: string;
    public firstName!: string;
    public address!: string;
    public zipCodeId!: number;
    public zipCode!: ZipCode | string;
    public zipCodeName!: string;
    public zipCodePlus4!: string;
    public phone!: string;
    public mobile!: string;
    public fax!: string;
}
